var map = {
	"./events-cat.webp": 2062,
	"./games-cat.webp": 2063,
	"./live-casino-cat.webp": 2064,
	"./lottery-cat.webp": 2065,
	"./other-cat.webp": 2066,
	"./p2p-cat.webp": 2067,
	"./pd-table.webp": 2068,
	"./privacy-policy-title-bm.webp": 2069,
	"./privacy-policy-title-cn.webp": 2070,
	"./privacy-policy-title-id.webp": 2071,
	"./privacy-policy-title.webp": 2072,
	"./promos-1.webp": 2073,
	"./promos-2.webp": 2074,
	"./promos-3.webp": 2075,
	"./promos-4.webp": 2076,
	"./question.webp": 2077,
	"./sideBar-bg.webp": 2078,
	"./slot-cat.webp": 2079,
	"./special-cat.webp": 2080,
	"./sports-cat.webp": 2081
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 473;